import { useMutation, useQuery } from '@tanstack/react-query';
import { publicFetch } from '@/lib/public-fetch';
/** Public: validate a reset token before showing the form. */
export function useValidateResetToken(token) {
    return useQuery({
        queryKey: ['password-reset', 'validate', token],
        enabled: !!token,
        queryFn: () => {
            if (!token)
                throw new Error('token required');
            return publicFetch(`/auth/password-reset/${encodeURIComponent(token)}`);
        },
        retry: false,
        gcTime: 0,
    });
}
/** Public: submit the new password with the reset token. */
export function useConfirmPasswordReset() {
    return useMutation({
        mutationFn: (dto) => publicFetch('/auth/password-reset', {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
    });
}
//# sourceMappingURL=usePasswordReset.js.map